import Account from "../../../classes/Account";
import { db } from "../../../boot/firebase";
import { collection, doc, deleteDoc, setDoc } from "firebase/firestore";

export const GET_ACCOUNT = async ({ dispatch }, id) => {
  return dispatch("GET_DOC", {
    converter: Account,
    path: Account.getPath(id),
    stateKey: "accounts",
    id,
  });
};

export const GET_ACCOUNTS = (
  { dispatch },
  { conditions, limit, pagination }
) => {
  return dispatch("GET_COLLECTION", {
    converter: Account,
    stateKey: "accounts",
    path: Account.getPath(),
    conditions,
    limit,
    pagination,
  });
};

export const LISTEN_ACCOUNT = ({ dispatch }, { id, next, error, unlisten }) => {
  return dispatch("LISTEN_DOC", {
    converter: Account,
    path: Account.getPath(id),
    stateKey: "accounts",
    id,
    next,
    error,
    unlisten,
  });
};

export const LISTEN_ACCOUNTS = (
  { dispatch },
  { next, pagination, error, unlisten }
) => {
  return dispatch("LISTEN_COLLECTION", {
    converter: Account,
    path: Account.getPath(),
    stateKey: "accounts",
    pagination,
    next,
    error,
    unlisten,
  });
};

export const SAVE_ACCOUNT = async ({ dispatch, state }, account) => {
  if (!account.data.created) {
    // New Account
    account.data.created = new Date();
    account.data.createdBy = state.user.id;

    const ref = doc(collection(db, Account.getPath()));
    account.id = ref.id;

    await setDoc(ref.withConverter(Account), account);
  } else {
    // Existing Account
    account.data.modified = new Date();
    account.data.modifiedBy = state.user.id;
    await setDoc(doc(db, account.path).withConverter(Account), account);
  }
  return account;
};

export const DELETE_ACCOUNT = async ({ commit }, id) => {
  await deleteDoc(doc(db, Account.getPath(id)));
  commit("REMOVE", { stateKey: "accounts", id });
};
